import React from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import { getTheme } from '../../../publicSession/selectors';
import { ThemeOptions } from '@wix/da-react-context/pkg/constants';
import s from './ThemeToggle.scss';
export default (({ className  })=>{
    const theme = useSelector(getTheme);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], theme === ThemeOptions.LIGHT && s['day'], className)
    }, /*#__PURE__*/ React.createElement("label", {
        className: s['toggle'],
        htmlFor: "checkbox"
    }, /*#__PURE__*/ React.createElement("i", {
        className: s['star']
    }), /*#__PURE__*/ React.createElement("i", {
        className: s['star']
    }), /*#__PURE__*/ React.createElement("i", {
        className: s['star']
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['star-trail']
    })), /*#__PURE__*/ React.createElement("i", {
        className: s['star']
    }), /*#__PURE__*/ React.createElement("span", {
        className: s['disc']
    }, /*#__PURE__*/ React.createElement("i", null)), /*#__PURE__*/ React.createElement("span", {
        className: classnames(s['cloud'], s['cloud1'])
    }), /*#__PURE__*/ React.createElement("span", {
        className: classnames(s['cloud'], s['cloud2'])
    })));
});
